import { render, staticRenderFns } from "./StcdR_Result_TransList.vue?vue&type=template&id=9c92412c"
import script from "./StcdR_Result_TransList.vue?vue&type=script&lang=js"
export * from "./StcdR_Result_TransList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports